import { useState } from 'react';

import { useIsomorphicLayoutEffect } from '@revenuemarket/react';
import { useRouter } from 'next/router';
import { SETTINGS_SIDEBAR_WIDTH } from '~components/ui/layout/LayoutSettings';
import {
  COLLAPSED_NAVIGATION_SIDEBAR_WIDTH,
  NAVIGATION_SIDEBAR_WIDTH,
} from '~components/ui/layout/Navigation';
import useNavigationStore from '~components/ui/layout/Navigation/useNavigationStore';
import useLayoutStore from '~store/layoutStore';

export const usePageWidth = (
  subtractWidth: number = 0,
  refs: React.RefObject<HTMLElement>[] = [],
) => {
  const router = useRouter();
  const { pinned } = useNavigationStore();
  const { isAiChatSidebarOpen } = useLayoutStore();
  const [refsWidth, setRefsWidth] = useState(0);

  // settings 페이지인지 체크
  const isSettingsPage = router.pathname.startsWith('/settings');
  const sidebarWidth = isSettingsPage
    ? SETTINGS_SIDEBAR_WIDTH
    : pinned
      ? NAVIGATION_SIDEBAR_WIDTH
      : COLLAPSED_NAVIGATION_SIDEBAR_WIDTH;

  useIsomorphicLayoutEffect(() => {
    if (refs.length === 0) {
      setRefsWidth((prev) => (prev === 0 ? prev : 0));
      return;
    }

    const callback = () => {
      const totalWidth = refs.reduce((acc, ref) => {
        if (ref.current == null) return acc;
        const { width } = ref.current.getBoundingClientRect();
        return acc + width;
      }, 0);
      setRefsWidth((prev) => (Math.abs(prev - totalWidth) >= 1 ? totalWidth : prev));
    };

    callback();

    const observers = refs.map((ref) => {
      if (ref.current == null) return null;
      const observer = new ResizeObserver(callback);
      observer.observe(ref.current);
      return observer;
    });

    return () => {
      observers.forEach((observer) => {
        if (observer) observer.disconnect();
      });
    };
  }, [refs.length, ...refs]);

  const width = `calc(100vw - ${sidebarWidth}px - ${subtractWidth}px - ${refsWidth}px - ${
    isAiChatSidebarOpen ? 400 : 0
  }px)`;

  return width;
};
